module.exports = __webpack_public_path__ + "images/blog/blog_card/coming_soon_23d9b1764284c224071a7d83e598d2c3.svg";